import React, { useState } from "react";
import {useTranslation} from "react-i18next";
const Accordion = () => {
  const [ t ] = useTranslation(['home']);
  const [LinkVideo, setText] = useState(
    "https://www.youtube.com/embed/kHaSlHbHkeU"
  );
  return (
    <div className="pt-10 mt-5 pb-5" id="FAQSection">
      <div className="container  ">
        <div className="row pt-5">
          <div className="col-12 col-lg-6">
            <label className="section-subtitle">FAQ</label>
            <h1 className="section-title rleft">{t('SolveYourDoubts')}</h1>
          </div>
          <div className="col-12 col-lg-8 ">
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    {t('WhatDoesAnNFToF')}
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>{t('WhatBenefitsAndUtilities')}</p>
                    <ul>
                      <li>
                        <p>
                          {t('ValidDigitalIdentity')}
                        </p>
                      </li>
                      <li>
                        <p>
                          {t('AccessToTheRacksStore')}
                        </p>
                      </li>
                      <li>
                        <p>{t('CustomizationOfRacks')}</p>
                      </li>
                      <li>
                        <p>
                          {t('AccessToPrivateEvents')}
                        </p>
                      </li>
                      <li>
                        <p>
                          {t('AirdropOfTheFuture')}
                        </p>
                      </li>
                      <li>
                        <p> {t('DeFiUtilities')} </p>
                      </li>
                      <li>
                        <p>
                          {t('VotingPowerInTheRacksDAO')} 🛣
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    {t('HowDoIGetARACKSNFT')}
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    {t('ToMintAnNFTOfRacksYou')}{" "}
                    <a
                      className="colordisabled"
                      href="https://opensea.io/collection/mrcrypto-by-racksmafia"
                      target="_blank"
                    >
                      Mr. Crypto by Racksmafia
                    </a>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingsFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive"
                    aria-expanded="false"
                    aria-controls="flush-collapseFive"
                  >
                    {t('HowDoIStart')}
                  </button>
                </h2>
                <div
                  id="flush-collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFive"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    {t('HowDoIStartDescription')} <br /> <br />
                    <ul>
                      <li>
                        <a
                          onClick={() =>
                            setText("https://www.youtube.com/embed/kHaSlHbHkeU")
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          <p>
                            {t('HowToInstall')} <span className="bold">METAMASK</span>{" "}
                            {t('WatchVideo')}
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() =>
                            setText("https://www.youtube.com/embed/hSmpOxKqO5g")
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          <p>
                            {t('HowToSend')} <span>MATIC</span> {t('From')}{" "}
                            <span>BINANCE</span> a <span>METAMASK</span>  {t('WatchVideo')}
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() =>
                            setText("https://www.youtube.com/embed/QVikss3ma0A")
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          <p>
                            {t('HowToBuyYourFirst')} <span>Mr. CRYPTO</span> {t('WatchVideo')}
                          </p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog  modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title " id="staticBackdropLabel"></h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <iframe
                width="100%"
                height="450"
                src={LinkVideo}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
